import React from 'react'
import './sec3.css';
import Bhlogo from '../../assets/qclogo.png';
// import BH1 from '../../assets/BH51.jpg';
// import BH2 from '../../assets/BH52.JPG';
// import BH3 from '../../assets/BH53.JPG';
// import BH4 from '../../assets/BH54.JPG';
// import BH5 from '../../assets/BH55.JPG';
// import BH6 from '../../assets/BH56.jpg';
import Rightslider from '../rightslider/Rightslider';
import { motion, setDragLock, transform } from 'framer-motion';
import { useInView } from 'react-intersection-observer';


const Sec3 = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, 
    threshold: 0.2,    
  });

  const textVariant = {
    hidden: { opacity: 0, y: 90},
    visible: { opacity: 1, y: 0, transition: { duration: 0.9 } }
  };
  const textLeft = {
    hidden: {opacity:0, x: -90},
    visible: {opacity:1, x:0, transition:{duration: 0.9}}
  }
  const textRight = {
    hidden: {opacity:0, x: 90},
    visible: {opacity:1, x:0, transition:{duration: 0.9}}
  }

  return (
    <div>
      <h1 style={{textAlign:"center",padding:"40px", fontSize:"3rem", fontWeight:"600"}}>Flagship Event</h1>
      <motion.div 
        className="beachhack"
        ref={ref}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        variants={textVariant}>
        <div className="beachhack-title">
          <div style={{display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center"}}>
            <h1 className="BEACH-HACKATHON"></h1>
            <img className="beachhack-logo-img" src={Bhlogo}/>
            <h1 className="BEACH-HACK-5" >Quizzitch Cup</h1>
          </div>
        </div>
        <div className="beachhack-paragraphs">
          <motion.p style={{textAlign: "justify", fontSize:"large"}} 
            ref={ref}
            initial="hidden"
            animate={inView ? 'visible' : 'hidden'}
            variants={textLeft}>Quizzitch Cup is the flagship event hosted by QuizInc, the official quiz club of NIT Durgapur. The 2024 edition, held from 8th to 10th March, brought together some of the brightest minds from across the country for an electrifying three-day quizzing extravaganza. Serving as a platform for students to showcase their knowledge, critical thinking, and teamwork, the event featured a series of thought-provoking rounds across various domains, blending intellect with enthusiasm. It not only tested participants’ depth of knowledge but also fostered a spirit of healthy competition and camaraderie.
          </motion.p>
          <motion.p style={{textAlign: "justify", fontSize:"large"}}
           ref={ref}
           initial="hidden"
           animate={inView ? 'visible' : 'hidden'}
           variants={textRight}>
          The Quizzitch Cup 2024 brought together participants from across the country, with over 300 registrations making it a grand celebration of intellect and creativity. The event featured activities like a movie night, a treasure hunt, and a cricket auction simulation, alongside quizzes on Business, Fandom, Cipherquest (NSFW), OTT and Sitcoms, Geopolitics, and Sports. A special highlight was the BMEP Quiz, where QuizInc collaborated with BMEP to host a quiz for underprivileged kids, adding a meaningful dimension to the event. The vibrant atmosphere and engaging rounds made it an unforgettable experience for all involved.
          </motion.p>
        </div>
        <Rightslider/>
      </motion.div>
    </div>
  )
}

export default Sec3